import { Images } from '@/theme/Images'
import PropTypes from 'prop-types'

const AmazonGiftCardBackdrop = ({ className = '' }) => (
  <div 
    className={`w-full md:w-[431px] h-[200px] md:h-[220px] flex items-center justify-center ${className}`}
    style={{ 
      backgroundColor: '#232F3E',
      borderRadius: '16px',
      boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)'
    }}
  >
    <img src={Images.amazonLogoWhite} className="max-w-[75%] max-h-[75%] object-contain" alt="Amazon Gift Card" />
  </div>
)

AmazonGiftCardBackdrop.propTypes = {
  className: PropTypes.string,
}

export default AmazonGiftCardBackdrop
